import { Component, Input } from '@angular/core';
import { RouterButton } from './model/router-button.model';

@Component({
    selector: 'c-router-button',
    templateUrl: './router-button.component.html',
    styleUrl: './router-button.component.css',
    standalone: false
})
export class RouterButtonComponent {
  @Input() buttons: RouterButton[] = [];
}
